import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { useAppDispatch, useAppSelector } from '@/redux/hooks/useAppState'
import {
	isInviteUsersDialogOpen,
	setIsInviteUsersDialogOpen,
} from '@/redux/store/slices/ui/uiSlice'
import ConnectionsRoutes from '@/routes/ConnectionsRoutes'
import { DataSourcesRoutes } from '@/routes/DataSourcesRoutes'
import { LocationsRoutes } from '@/routes/LocationsRoutes'
import { SettingsRoutes } from '@/routes/SettingsRoutes'
import { ThemeDemo } from '@/routes/ThemeDemo'
import { Outlet, Route, Routes } from 'react-router-dom'

import { GridsRoutes } from '../Grids/GridRoutes'
import { InviteUser } from '../InviteUser'
import { WorkspaceNavigation } from './WorkspaceNavigation/WorkspaceNavigation'

export const WorkspaceContainer = () => {
	const isInviteOpen = useAppSelector(isInviteUsersDialogOpen)
	const dispatch = useAppDispatch()

	return (
		<SidebarProvider defaultOpen={false}>
			<div className="flex h-screen bg-background w-full">
				<WorkspaceNavigation />
				<SidebarInset className="flex flex-col">
					<div className="flex flex-1 min-h-0">
						<Routes>
							<Route element={<Outlet />}>
								<Route path="grids/*" element={<GridsRoutes />} />
								<Route path="locations/*" element={<LocationsRoutes />} />
								<Route path="connections/*" element={<ConnectionsRoutes />} />
								<Route path="settings/*" element={<SettingsRoutes />} />
								<Route path="data-sources/*" element={<DataSourcesRoutes />} />
								<Route path="theme-demo" element={<ThemeDemo />} />
							</Route>
						</Routes>
					</div>
				</SidebarInset>
				<InviteUser
					isOpen={isInviteOpen}
					onCancel={() => dispatch(setIsInviteUsersDialogOpen(false))}
					onSubmit={() => dispatch(setIsInviteUsersDialogOpen(false))}
				/>
			</div>
		</SidebarProvider>
	)
}
